var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value.Prop
    ? _c("div", { style: _vm.value.getStyle() }, [
        _c("img", {
          style: _vm.value.getImgStyle(),
          attrs: {
            src: require("@/assets/img/logo_r.png"),
            alt: "Voorbeeld logo",
          },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }